export const UP = { name: 'UP', horizontal: false };
export const LEFT = { name: 'LEFT', horizontal: true };
export const RIGHT = { name: 'RIGHT', horizontal: true };
export const DOWN = { name: 'DOWN', horizontal: false };
export const UNKNOWN = { name: 'UNKNOWN', horizontal: null };
const eventCountNeeded = 3;
export default function () {
    let lastTouches = [];
    let initialSwipeDirection = UNKNOWN;
    const swipeDirection = ({ horizontalAllowed, verticalAllowed, }) => {
        const oldestTouch = lastTouches[Math.max(0, lastTouches.length - eventCountNeeded)];
        const latestTouch = lastTouches[lastTouches.length - 1];
        if (!oldestTouch || !latestTouch) {
            return null;
        }
        const diffX = Math.abs(oldestTouch.pageX - latestTouch.pageX);
        const diffY = Math.abs(oldestTouch.pageY - latestTouch.pageY);
        const upOrDown = oldestTouch.pageY - latestTouch.pageY > 0 ? UP : DOWN;
        const leftOrRight = oldestTouch.pageX - latestTouch.pageX > 0 ? LEFT : RIGHT;
        if (horizontalAllowed && verticalAllowed) {
            return diffY > diffX ? upOrDown : leftOrRight;
        }
        else if (horizontalAllowed) {
            return leftOrRight;
        }
        else {
            return upOrDown;
        }
    };
    let rafId = null;
    let timestamp = Date.now();
    let velocityY = 0;
    let velocityX = 0;
    let frameX = 0;
    let frameY = 0;
    let offsetY = 0;
    let offsetX = 0;
    const track = () => {
        const now = Date.now();
        const elapsed = now - timestamp;
        timestamp = now;
        const deltaY = offsetY - frameY;
        const deltaX = offsetX - frameX;
        frameX = offsetX;
        frameY = offsetY;
        const vX = (1000 * deltaX) / (1 + elapsed);
        const vY = (1000 * deltaY) / (1 + elapsed);
        velocityX = 0.8 * vX + 0.2 * velocityX;
        velocityY = 0.8 * vY + 0.2 * velocityY;
        rafId = requestAnimationFrame(track);
    };
    return {
        push(touch) {
            if (!lastTouches.length) {
                frameX = touch.pageX;
                frameY = touch.pageY;
            }
            offsetX = touch.pageX;
            offsetY = touch.pageY;
            let currentSwipeDirection;
            if (initialSwipeDirection === UNKNOWN) {
                currentSwipeDirection = UNKNOWN;
            }
            else if (initialSwipeDirection.horizontal) {
                currentSwipeDirection = swipeDirection({ horizontalAllowed: true, verticalAllowed: false });
            }
            else {
                currentSwipeDirection = swipeDirection({ horizontalAllowed: false, verticalAllowed: true });
            }
            lastTouches.push({
                pageX: touch.pageX,
                pageY: touch.pageY,
                swipeDirection: currentSwipeDirection,
            });
            if (lastTouches.length === eventCountNeeded) {
                initialSwipeDirection = swipeDirection({ horizontalAllowed: true, verticalAllowed: true });
            }
        },
        reset() {
            initialSwipeDirection = UNKNOWN;
            lastTouches = [];
        },
        startTrackingVelocity() {
            if (rafId === null) {
                rafId = requestAnimationFrame(track);
            }
        },
        stopTrackingVelocity() {
            cancelAnimationFrame(rafId);
            rafId = null;
        },
        isSwiping(...directions) {
            const swipeDirection = this.swipeDirection();
            for (let i = 0; i < directions.length; i++) {
                if (directions[i] === swipeDirection) {
                    return true;
                }
            }
        },
        firstEvent() {
            if (!lastTouches.length) {
                throw new Error('Cannot get first touch event when no events have been registered');
            }
            return lastTouches[0];
        },
        swipeVelocity() {
            return {
                horizontal: velocityX,
                vertical: velocityY,
            };
        },
        swipeDirection() {
            const lastEvent = lastTouches[lastTouches.length - 1];
            return lastEvent ? lastEvent.swipeDirection : UNKNOWN;
        },
    };
}
